class ApiCodeEnum {
  static APPLICANTS = {
    TERMSOFSERVICE_ALREADY_ACCEPTED: 'applicants.termsofservice_already_accepted',
  };
}

export default ApiCodeEnum;
